<script setup lang="ts">
import { ref } from "vue"

//================================================
//                  Props
//================================================
type Props = {
    tags: string[]
    readonly?: boolean
}

const emit = defineEmits(["click:add"])

withDefaults(defineProps<Props>(), {
    tags: (): string[] => [],
    readonly: false,
})

/**
 * Liste des références des composants BaseChips
 */
const chipList = ref<any>([])
/**
 * Indique si le texte est en overflow
 * @param slot - Slot de la cellule
 */
function isTextOverflowing(value: string, index: number) {
    if (!value) {
        return null
    }

    const chip = chipList.value[index]

    if (!chip) {
        return null
    }

    const label = chip.$el?.querySelector(".text-chip")

    if (!label) {
        return null
    }

    const isOverflowing = label.scrollWidth > label.clientWidth

    return isOverflowing
        ? {
              value,
          }
        : null
}
</script>
<template>
    <div class="list-building-tags">
        <BaseButton
            v-if="!readonly"
            severity="contrast"
            class="list-building-tags__button-add"
            rounded
            icon="pi pi-plus"
            @click="emit('click:add')"
        >
        </BaseButton>
        <BaseChip
            v-for="(tag, index) in tags.slice(0, 1)"
            :key="tag"
            :label="tag"
            :pt="{
                label: 'text-chip whitespace-nowrap overflow-x-hidden text-ellipsis',
            }"
            class="chip"
            ref="chipList"
            v-tooltip="isTextOverflowing(tag, index)"
        />
        <BaseChip
            v-if="tags.length > 1"
            class="chip-plus"
            :pt="{
                label: 'text-chip',
            }"
            :label="`+${tags.length - 1}`"
            v-tooltip.bottom="{
                value: tags
                    .map((t) => `&#9679; ${t}`)
                    .slice(1)
                    .join('\n'),
            }"
        />
    </div>
</template>

<style scoped>
.list-building-tags {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;

    --button-add-size: 2rem;

    .list-building-tags__button-add {
        width: var(--button-add-size);
        min-width: var(--button-add-size);
        min-height: var(--button-add-size);
        height: var(--button-add-size);
    }
}

.chip {
    padding: 0.33rem 0.66rem;
    max-width: 4rem;
}
.chip-plus {
    padding: 0.33rem 0.66rem;
}
</style>
<style>
.list-buildings-tags-chip-label {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
